import {useQuery} from '@tanstack/react-query'
import api from 'src/services/api'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'

type Props = {
  enabled: boolean
  filter: {
    clientIds?: Array<number>
    cameraIds?: Array<number>
    companyIds?: Array<number>
    objectTypes?: Array<string>
  }
  start: string
  end: string
}

export default function useDashboardCountByObjectTypes({enabled, filter, start, end}: Props) {
  const query = useQuery({
    refetchOnWindowFocus: false,
    enabled,
    queryKey: [QueryKeyEnum.DASHBOARD_COUNT_BY_OBJECT_TYPES, filter, start, end],
    queryFn: async () => (await api.reports.getCountByObjectTypes({filter, start, end})).data.data,
  })

  return query
}
